module.exports = __webpack_public_path__ + "static/media/logo.13eab5b5.svg";